import React from "react";
import styles from "./Footer.module.scss";

const Footer = () => {
  const links = <ul className={`clearfix ${styles.links}`}>
    <li className={styles.item}><a
      href={'https://www.customerservice.nsw.gov.au/terms'}
      target={'_blank'}>Terms</a></li>
    <li className={styles.item}><a
      href={'https://www.customerservice.nsw.gov.au/disclaimer'}
      target={'_blank'}>Disclaimer</a></li>
    <li className={styles.item}><a
      href={'https://www.customerservice.nsw.gov.au/privacy'}
      target={'_blank'}>Privacy</a></li>
    <li className={styles.item}><a
      href={'https://www.customerservice.nsw.gov.au/copyright'}
      target={'_blank'}>Copyright</a></li>
  </ul>;
  return <footer>
    <div className={styles.upperFooterContainer}>
      <div className={styles.upperFooter}>
        <p>
          If you have any questions or concerns about this service, please call the ANZ Estates Team on 1800 237 170
          from 8.00am and 5:30pm (AEST) Monday to Friday excluding public holidays.
        </p>
      </div>
    </div>
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <p>We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued
          connection to their country and culture.</p>
        <div className={styles.divider}/>
        <div>
          {links}
          <small className={styles.small}>Copyright © 2019 Department of Customer Service</small>
        </div>
      </div>
    </div>
  </footer>;
};

export default Footer;
